var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default"),_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.isWinter && _vm.showSnow),expression:"isWinter && showSnow"}],ref:"canvas",staticClass:"xmas__canvas"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }